<template>
  <div class="Md">
    <div class="markdown" v-if="ismd">
      <div class="md fs22">
        <vue_markdown :source="mdtext"></vue_markdown>
      </div>
    </div>
    <div v-else class="pdf" >
      <pdf :src="pdfdata" v-for="i in numPages" :key="i" :id="i" :page="i"
           :scale.sync="scale" >
        <template slot="loading">
          loading content here...
        </template>
      </pdf>
    </div>
  </div>
</template>

<script>
 // @ is an alias to /src

 import VueMarkdown from 'vue-markdown'
 import pdfvuer from 'pdfvuer'

 export default {
   name: 'Md',
   data () {
     return {
       ismd: true,
       link: '',
       mdtext: '',
       numPages: 0,
       pdfdata: undefined
     }
   },
   mounted() {
     let that = this
     this.link = this.$route.params.link
     this.ismd = this.link.endsWith('.md')
     if(this.ismd){
       this.$http.get(this.link)
           .then(res => {
             that.mdtext = res.data
           })
     }
     else{
       this.getPdf()
     }
   },
   methods: {
     getPdf () {
       this.pdfdata = pdfvuer.createLoadingTask(this.link);
       this.pdfdata.then(pdf => {
         this.numPages = pdf.numPages
       })
     }
   },
   components: {
     vue_markdown: VueMarkdown,
     pdf: pdfvuer
   }
 }
</script>

<style scoped>
 .markdown, .pdf{
   margin-top: 5.2vw;
   margin-bottom: 5.2vw;
   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content: center;
 }
 .md{
   width: 62.5vw;
   text-align: left;
   background-color: #22277c;
   color: white;
   box-sizing: border-box;
   padding: 3.125vw 2.6vw 1vw 2.6vw;
   line-height: 1.875vw;
 }

 @media (min-width: 320px) and (max-width: 480px) {
   .md{
     width: 100vw;
     line-height: normal;
   }
 }

</style>
<style>
 .md a{
   color: #FFBA84 !important;
 }
</style>
